<template>
  <div class="home">

  </div>
</template>

<script>
  export default {
    name: 'home',
    data() {
      return {
        userRole: '0'
      };
    },
    mounted() {
      this.userRole = this.$route.query.role || '0';
      if (this.userRole === '0') { // 个人
        // 获取用户信息
        if (this.getCookie('userInfo')) {
          this.$router.push('/user');
        } else {
          this.$router.push('/login?role=0');
        }
      } else {
        if (this.getCookie('merchantInfo')) {
          this.$router.push('/writeOff');
        } else {
          this.$router.push('/login?role=1');
        }
      }
    },
    methods: {},
    computed: {},
    components: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .home {
    min-height: 100%;
    background: url("../assets/img/topImg_user.jpg") 0 0 no-repeat;
    background-size: 100%;
  }

</style>



// WEBPACK FOOTER //
// home.vue?deb11ae8